import Swiper, {Navigation} from 'swiper'

const selectors = {
  clients: '[data-clients]',
  clientsPause: '[data-clients-pause]',
  clientsPlay: '[data-clients-play]',
}

const initClientsSwiper = () => {
  const clients = document.querySelectorAll(selectors.clients)

  clients.forEach((client) => {
    const swiper = new Swiper(client.querySelector('.clients__items.swiper'), {
      modules: [Navigation],
      slidesPerView: 'auto',
      spaceBetween: 32,
      loop: true,

      navigation: {
        nextEl: '.clients__swiper-nav.next',
        prevEl: '.clients__swiper-nav.prev',
      },

      breakpoints: {
        768: {
          spaceBetween: 64,
        },
      },
    })
  })
}

export default initClientsSwiper
